/** @format */
import { axiosApi } from "../axios/axios_config";
export async function getNeuroData() {
  try {
    // Get user information from localStorage
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const userId = userInfo?.id; // Extract userId from userInfo

    // Handle case where userId is not available
    if (!userId) {
      throw new Error("User ID not found in localStorage.");
    }

    const { data, response } = await axiosApi({
      endpoint: `neuro?userId=${userId}`,
      method: "GET",
      bodyData: null,
    });

    return { data, response };
  } catch (err) {
    console.error("Error fetching neuro data:", err.message);
    throw err;
  }
}


export async function neuroTestData(sessionId, tableName) {
  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const userId = userInfo?.id; // Extract userId from userInfo
    if (!userId) {
      throw new Error("User ID not found in localStorage.");
    }
    const bodyData = {
      sessionId,
      tableName,
    };

    // Make API call using axiosApi
    const { data, response } = await axiosApi({
      endpoint: `neuro/tests?userId=${userId}`,
      method: "POST",
      bodyData,
    });

    return { data, response };
  } catch (err) {
    console.error("Error posting neuro test data:", err.message);
    throw err;
  }
}